import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { isFileImage } from "../../utils/isMage";
import { toggleMute } from "../../redux/user/userReducer";
import VideoControls from "./VideoControls";

const Media = forwardRef(({
    className,
    controls,
    autoPlay,
    source,
    fileType,
    duration,
    vidObjectFit = 'cover',
    onClick,
    style,
    onTimeUpdate,
    muted,
    thumbnailUrl,
    handleFullscreen,
    isPost
}, ref) => {
    const dispatch = useDispatch()
    const videoRef = useRef(null);
    useImperativeHandle(ref, () => videoRef.current);
    const isImage = isFileImage(fileType)
    const [isFullscreen, setIsFullscreen] = useState(false);
    
    useEffect(() => {
        const handleFullscreenChange = () => {
            setIsFullscreen(!!document.fullscreenElement);
        };

        document.addEventListener("fullscreenchange", handleFullscreenChange);
        return () => {
            document.removeEventListener("fullscreenchange", handleFullscreenChange);
        };
    }, []);

    if (isImage) {
        return (
            <img
                loading="lazy"
                onClick={onClick}
                src={source}
                alt={`media`}
                style={style}
                className={`relative w-full ${className}`}
            />
        )
    } else {
        return (
            <div className={`relative group w-full ${className}`}>
                <video
                    ref={videoRef}
                    src={source}
                    onClick={onClick}
                    onTimeUpdate={onTimeUpdate}
                    poster={thumbnailUrl}
                    onVolumeChange={() => {
                        const video = videoRef.current
                        if (video.muted) {
                            dispatch(toggleMute(true))
                        }
                    }}
                    preload="metadata"
                    playsInline
                    autoPlay={autoPlay}
                    muted={muted}
                    style={{ objectFit: isFullscreen ? "contain" : vidObjectFit, style }} // Apply object-fit to videos
                    className={`relative w-full ${className}`}  // Ensure video fills the container
                />
                {controls && <VideoControls ref={videoRef} isPost={isPost} handleFullscreen={handleFullscreen} videoDuration={duration} />}
            </div>
        )
    }
});

export default Media;


